import Router, { Route, Switch } from '@alltrails/shared/components/ReactRouter';
import ApplicationLayout from 'components/ApplicationLayout/ApplicationLayout';
import CustomProvider from 'components/CustomProvider';
import PlusLandingPage from 'components/LandingPages/PlusLandingPage';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import Plan from 'types/Plan';
import { UserId } from '@alltrails/shared/types/User';
import PodcastLandingPage from 'components/LandingPages/PodcastLandingPage';
import PetSmartLandingPage from 'components/LandingPages/PetSmartLandingPage';
import TiktokLandingPage from 'components/LandingPages/TiktokLandingPage';
import KathmanduLandingPage from 'components/LandingPages/KathmanduLandingPage';
import CheckoutRoute from './CheckoutRoute';
import LoginRoute from './LoginRoute';
import RegisterRoute from './RegisterRoute';

type ProRouterProps = {
  isPromoEligible: boolean;
  coupon?: Coupon;
  currencyCode: CurrencyCode;
  userId?: UserId;
  whenExpired: string;
  trialPlan: Plan;
  nonTrialPlan: Plan;
};

function ProRouter({ isPromoEligible, currencyCode, coupon, userId, whenExpired, trialPlan, nonTrialPlan }: ProRouterProps) {
  const params = new URLSearchParams(__AT_DATA__.search);

  const plan = !params.has('multiyear_conversion') && !coupon && isPromoEligible ? trialPlan : nonTrialPlan;

  return (
    <Router fullpath={global.__AT_DATA__.pathname}>
      <Switch>
        <Route path="/:locale?/signup">
          <ApplicationLayout>
            <RegisterRoute coupon={coupon} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/login">
          <ApplicationLayout>
            <LoginRoute coupon={coupon} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/podcast">
          <ApplicationLayout>
            <PodcastLandingPage coupon={coupon} plan={plan} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/petsmart">
          <ApplicationLayout>
            <PetSmartLandingPage coupon={coupon} plan={plan} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/tiktok">
          <ApplicationLayout>
            <TiktokLandingPage coupon={coupon} plan={plan} userId={userId} currencyCode={currencyCode} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/meta">
          <ApplicationLayout>
            <PlusLandingPage coupon={coupon} plan={plan} userId={userId} currencyCode={currencyCode} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/kathmandu">
          <ApplicationLayout>
            <KathmanduLandingPage coupon={coupon} plan={plan} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/plus">
          <ApplicationLayout>
            <PlusLandingPage coupon={coupon} currencyCode={currencyCode} plan={plan} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/plus/checkout">
          <CheckoutRoute
            coupon={coupon}
            currencyCode={currencyCode}
            nonTrialPlan={nonTrialPlan}
            plan={plan}
            userId={userId}
            whenExpired={whenExpired}
          />
        </Route>
        <Route path="/:locale?/plus/signup">
          <ApplicationLayout>
            <RegisterRoute />
          </ApplicationLayout>
        </Route>
      </Switch>
    </Router>
  );
}

type Props = {
  coupon?: Coupon;
  currencyCode: CurrencyCode;
  isPromoEligible: boolean;
  nonTrialPlan: Plan;
  trialPlan: Plan;
  userId?: UserId;
  whenExpired: string;
};

export default function Pro({ isPromoEligible, currencyCode, coupon, userId, whenExpired, trialPlan, nonTrialPlan }: Props) {
  return (
    <CustomProvider>
      <ProRouter
        coupon={coupon}
        currencyCode={currencyCode}
        isPromoEligible={isPromoEligible}
        nonTrialPlan={nonTrialPlan}
        trialPlan={trialPlan}
        userId={userId}
        whenExpired={whenExpired}
      />
    </CustomProvider>
  );
}
